module.exports = {
    Ageras: 'ageras',
    Billy: 'billy'
}
